export enum AuditLogCategories {
    SMS = 'SMS',
    EMAIL = 'EMAIL',
    STRIPE = 'STRIPE',
    USER_ACTION = 'USER ACTION',
    ADMIN_ACTION = 'ADMIN ACTION',
    VOUCHER = 'VOUCHER',
    PAYMENT = 'PAYMENT',
}
